import {useQuery} from '@tanstack/react-query'
import {
  GetSiemS3IntegrationResponse,
  SiemS3Status,
  SiemS3ConfigNode,
} from 'interfaces'
import {useMemo} from 'react'
import {SIEMService} from 'services/api'

const siemS3SettingInitState: GetSiemS3IntegrationResponse = {
  config: {} as SiemS3ConfigNode,
  status: '' as SiemS3Status,
  lastSynced: '',
  error: '',
}
export interface SiemS3IntegrationQueryResult {
  siemStatus: SiemS3Status
  siemRegion: string
  siemBucketName: string
  siemPolicy: string
  siemConnectionError: string
  siemLastSynced: string
  isLoading: boolean
  isFetching: boolean
  isSuccess: boolean
  refetch: () => void
}
export const SIEM_S3_QUERY_KEY = 'getSiemS3Integration'
export const useSiemS3IntegrationQuery = (): SiemS3IntegrationQueryResult => {
  const {data, isLoading, isFetching, isSuccess, refetch} = useQuery({
    queryKey: [SIEM_S3_QUERY_KEY],
    queryFn: () => SIEMService.getSiemS3Integration(),
    select: ({data}) => data,
    refetchOnWindowFocus: false,
  })
  const siemRes = {...siemS3SettingInitState, ...data}

  // selectors
  const siemSelectors = useMemo(() => {
    const {
      config: {bucketName = '', region, policy = {}} = {},
      error,
      lastSynced = '',
      status,
      region: regionName = '',
    } = siemRes

    return {
      siemStatus: status,
      siemRegion: region ?? regionName,
      siemBucketName: bucketName,
      siemPolicy: JSON.stringify(policy, null, 2),
      siemLastSynced: lastSynced,
      siemConnectionError: error ?? '',
    }
  }, [siemRes])

  return {
    ...siemSelectors,
    isLoading,
    isFetching,
    isSuccess,
    refetch,
  }
}
